module.exports = __webpack_public_path__ + "media/images/signup-bg-62366fa33e31295e1f81854daec4a651.jpg";